export const LIST_CORZAP_REPORTS = "LIST_CORZAP_REPORTS";
export const LIST_CORZAP_REPORTS_ERROR = "LIST_CORZAP_REPORTS_ERROR";
export const LIST_CUSTOM_REPORTS = "LIST_CUSTOM_REPORTS";
export const LIST_CUSTOM_REPORTS_ERROR = "LIST_CUSTOM_REPORTS_ERROR";
export const SAVE_CUSTOM_REPORT = "SAVE_CUSTOM_REPORT";
export const GET_REPORT_DATA = "GET_REPORT_DATA";
export const GET_REPORT_DATA_ERROR = "GET_REPORT_DATA_ERROR";
export const CHANGE_SEARCH_CRITERIA = "CHANGE_SEARCH_CRITERIA";
export const RESET_SEARCH_CRITERIA = "RESET_SEARCH_CRITERIA";
export const CLEAR_REPORT_DATA = "CLEAR_REPORT_DATA";
export const SET_LOADING_REPORT_DATA = "SET_LOADING_REPORT_DATA";
export const SET_LOADING_REPORTS = "SET_LOADING_REPORTS";
export const SET_LOADING_DEFAULT_REPORTS = "SET_LOADING_DEFAULT_REPORTS";
